<div [@routeAnimations]="prepareRoute(outlet, 'animation')">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
